<template>
	<div id="app">
		<router-view :key="$store.state.user.componentKey" />
	</div>
</template>

<script>
	export default {
		data() {
			return {


			};
		},
		mounted() {
			// console.log('app----------',this.$store.state.user.componentKey)
		},
		methods: {

		}
	};
</script>

<style lang="less">
	#app {
		// color: #2c3e50;
	}

	#nav {
		padding: 30px;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
</style>